import { Button } from '@bcecloud/portal-ui';
import { ActionCard } from '@/embed/ActionCard';
import type { EmbedWidgetProps } from '@/embed/types';
import { REPEAT_CLIENTS_PATH } from '@/lib/repeat-clients';

/** Opens a bcecloud path in a new top-level tab (the staff member's real session). */
function openInBcecloud(path: string): void {
  window.open(`${window.location.origin}${path}`, '_blank', 'noopener,noreferrer');
}

/**
 * The reach-out widget — the Salesforce-facing entry to bcecloud's "who to
 * reach out to next" worklist. This is the embed **seam**: the ranked queue,
 * its scoring, and the per-client workflow are built in bcecloud (Repeat clients
 * track); this surfaces that list from inside Salesforce. It is not record-
 * bound, so it is placed on an App/Home page or tab rather than a record page.
 *
 * @returns The reach-out entry widget.
 */
export function OutreachWidget(_props: EmbedWidgetProps): React.ReactElement {
  return (
    <ActionCard
      title="Who to reach out to next"
      description="Your past clients, ranked by who is due for another event."
    >
      <div className="space-y-2">
        <p className="text-portal-small text-portal-muted">
          The ranked worklist — each client's booking history, why they are due, and a
          suggested reach-out — lives in bcecloud.
        </p>
        <Button variant="primary" onClick={() => openInBcecloud(REPEAT_CLIENTS_PATH)}>
          Open reach-out list
        </Button>
      </div>
    </ActionCard>
  );
}
